/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Go_To_SettingsInputs */

const en_go_to_settings = /** @type {(inputs: Go_To_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to Settings`)
};

const ar_go_to_settings = /** @type {(inputs: Go_To_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الانتقال إلى الإعدادات`)
};

const de_go_to_settings = /** @type {(inputs: Go_To_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zu den Einstellungen`)
};

const es_go_to_settings = /** @type {(inputs: Go_To_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir a Ajustes`)
};

const fr_go_to_settings = /** @type {(inputs: Go_To_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir les Paramètres`)
};

const it_go_to_settings = /** @type {(inputs: Go_To_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai alle Impostazioni`)
};

const ja_go_to_settings = /** @type {(inputs: Go_To_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`設定へ`)
};

const ko_go_to_settings = /** @type {(inputs: Go_To_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`설정으로 이동`)
};

const pt_br_go_to_settings = /** @type {(inputs: Go_To_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir para Configurações`)
};

const ru_go_to_settings = /** @type {(inputs: Go_To_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перейти в Настройки`)
};

const th_go_to_settings = /** @type {(inputs: Go_To_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไปที่การตั้งค่า`)
};

const tr_go_to_settings = /** @type {(inputs: Go_To_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ayarlar’a Git`)
};

const zh_cn_go_to_settings = /** @type {(inputs: Go_To_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前往设置`)
};

const zh_tw_go_to_settings = /** @type {(inputs: Go_To_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前往設定`)
};

/**
* | output |
* | --- |
* | "Go to Settings" |
*
* @param {Go_To_SettingsInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const go_to_settings = /** @type {((inputs?: Go_To_SettingsInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Go_To_SettingsInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_go_to_settings(inputs)
	if (locale === "ar") return ar_go_to_settings(inputs)
	if (locale === "de") return de_go_to_settings(inputs)
	if (locale === "es") return es_go_to_settings(inputs)
	if (locale === "fr") return fr_go_to_settings(inputs)
	if (locale === "it") return it_go_to_settings(inputs)
	if (locale === "ja") return ja_go_to_settings(inputs)
	if (locale === "ko") return ko_go_to_settings(inputs)
	if (locale === "pt_br") return pt_br_go_to_settings(inputs)
	if (locale === "ru") return ru_go_to_settings(inputs)
	if (locale === "th") return th_go_to_settings(inputs)
	if (locale === "tr") return tr_go_to_settings(inputs)
	if (locale === "zh_cn") return zh_cn_go_to_settings(inputs)
	return zh_tw_go_to_settings(inputs)
});